export const types = {
    CONNECT: 'CONNECT',
    SELECT: 'SELECT',
    CRUD: 'INSERT-UPDATE-DELETE',
    DELETE: 'DELETE'
};